import React, { useContext } from 'react';

import { AppContext } from '../../../app.context';
import { NavigationLink, SidebarProps } from '../sidebar.type';
import { NavigationSection, ProfileSection } from '../components';

import { LogoSection } from './components';
import { SidebarMobileWrapper, ContentWrapper } from './sidebar-mobile.style';

const SidebarMobile: React.FC<SidebarProps> = ({
  homePath,
  navigationSections,
  userName,
  userCompanyName,
  onNavigationLinkClick,
  onUserProfileClick,
  onUserManagementClick,
  onLogoutClick,
  pwaInstallEvent,
}: SidebarProps) => {
  const { isSidebarOpen, toggleSideBar } = useContext(AppContext);
  const isMobileSidebarOpen = !isSidebarOpen;

  const handleNavigationLinkClicked = (navigationLink: NavigationLink) => {
    toggleSideBar();
    onNavigationLinkClick(navigationLink);
  };

  if (!isMobileSidebarOpen) {
    return null;
  }

  return (
    <SidebarMobileWrapper>
      <LogoSection homePath={homePath} onCloseSidebarClick={toggleSideBar} />
      <ContentWrapper>
        <NavigationSection
          isSidebarOpen={isMobileSidebarOpen}
          onNavigationLinkClick={handleNavigationLinkClicked}
          navigationSections={navigationSections}
        />
        <ProfileSection
          pwaInstallEvent={pwaInstallEvent}
          isSidebarOpen={isMobileSidebarOpen}
          userName={userName}
          userCompanyName={userCompanyName}
          onUserProfileClick={onUserProfileClick}
          onUserManagementClick={onUserManagementClick}
          onLogoutClick={onLogoutClick}
        />
      </ContentWrapper>
    </SidebarMobileWrapper>
  );
};

export { SidebarMobile };
